import { ApolloClient, NormalizedCacheObject } from "@apollo/client";

import { ReducerCreators } from "@reduxjs/toolkit";

/**
 * Wraps a slice's reducer creators so inline thunks are typed with the Apollo
 * `client` injected as the store's thunk extra argument.
 *
 * Kept in-app (rather than imported from `@covertree/new-business-redux`) so the
 * endorsement slices stay self-contained and don't break tests that mock that
 * package.
 */
export const typedReducerCreator = <T>(create: ReducerCreators<T>) => {
  const createWithType = create.asyncThunk.withTypes<{
    extra: { client: ApolloClient<NormalizedCacheObject> };
  }>();

  return { create, createWithType };
};
